// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__container-ZN5o3Q","transparent":"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__transparent-WhtwOG","readonly":"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__readonly-VeHR_q","viewer":"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__viewer-PgW01T"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__container-ZN5o3Q\",\"transparent\":\"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__transparent-WhtwOG\",\"readonly\":\"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__readonly-VeHR_q\",\"viewer\":\"src-app-components-forms-FormatNumberTextBox-FormatNumberTextBox-module__viewer-PgW01T\"}";
        // 1789362522819
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  